import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    GridContainer,
    GridItem2xs4,
    GridItem3xs10,
    GridItem4xs8,
    GridItem5xs10,
    GridItem6,
    GridItem8sm12xs12,
    GridItem9,
    //GridItem12,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import { 
    TextValidatorNumber,
    TextValidatorNumberRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import tipoMomentoTributacaoIRList from '../../../business-rules/List/tipoMomentoTributacaoIRList'

import {
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    tipoRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentosList,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'

import {
    processaValoresDefaultIniciaisConfiguracaoGestaoPatrimonial,
} from './EstudoServiceConfiguracaoGestaoPatrimonial'

import {
    ExibirCapitalSeguradoCarteiraInvestimentos,
    IncluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia,
    UtilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia,
} from './EstudoCompConfiguracao'



const EstudoFormConfiguracaoGestaoPatrimonial = ( { values, handleChange, handleSubmit/*, popup*/ } ) => {

    processaValoresDefaultIniciaisConfiguracaoGestaoPatrimonial(values)

    //const GridItemConfiguracaoGestaoPatrimonial = popup ? GridItem12 : GridItem8sm12xs12

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className={"justify-center"/* + (popup ? ' mt-5' : '')*/}
            >
                <GridItem8sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.carteiraInvestimentos}
                        >
                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirTabelaEvolucaoValorResgateCarteiraInvestimentos"
                                        label={LABEL.exibirTabelaEvolucaoValorResgateCarteiraInvestimentos}
                                        checked={values.exibirTabelaEvolucaoValorResgateCarteiraInvestimentos}
                                        onChange={handleChange}
                                    />
                                </GridItem9>

                                <GridItem9>
                                    <ExibirCapitalSeguradoCarteiraInvestimentos
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem9>

                                {/*(
                                    values.exibirTabelaEvolucaoValorResgateCarteiraInvestimentos ||
                                    values.exibirCapitalSeguradoCarteiraInvestimentos
                                ) && (
                                    <GridItem9
                                        className='ml-15'
                                    >
                                        <CheckboxPadrao
                                            name="exibirEconomiaInventarioSeguroVidaCarteiraInvestimentos"
                                            label={LABEL.exibirEconomiaInventarioSeguroVidaCarteiraInvestimentos}
                                            checked={values.exibirEconomiaInventarioSeguroVidaCarteiraInvestimentos}
                                            onChange={handleChange}
                                        />
                                    </GridItem9>
                                )*/}

                                <GridItem6>
                                    <CheckboxPadrao
                                        name="premioVidaInteiraOriundoCarteiraInvestimentos"
                                        label={LABEL.premioVidaInteiraOriundoCarteiraInvestimentos}
                                        checked={values.premioVidaInteiraOriundoCarteiraInvestimentos}
                                        onChange={handleChange}
                                    />
                                </GridItem6>

                                {values.premioVidaInteiraOriundoCarteiraInvestimentos && (
                                    <GridItem5xs10>
                                        <TextFieldNumberSelectRequired
                                            name={"idRecursoFinanceiroOrigemOrigemPremioVidaInteira"}
                                            label={LABEL.idRecursoFinanceiroOrigemOrigemPremioVidaInteira}
                                            value={values.idRecursoFinanceiroOrigemOrigemPremioVidaInteira || ''}
                                            onChange={handleChange}
                                            list={tipoRecursoFinanceiroOrigemRealocacaoCarteiraInvestimentosList(values, {})}
                                        />
                                    </GridItem5xs10>
                                )}

                                {existeTabelaEvolucaoValorResgate(values, HARDCODE.idFamiliarCliente) && (
                                    <GridItem3xs10>
                                        <TextValidatorNumber
                                            name={"idadeSimularResgateVidaInteiraCliente"}
                                            label={LABEL.idadeSimularResgateVidaInteira.replace("$1$", tituloCliente(values))}
                                            value={
                                                values.idadeSimularResgateVidaInteiraCliente === 0
                                                    ?
                                                        0
                                                    :
                                                        values.idadeSimularResgateVidaInteiraCliente || ''
                                            }
                                            onChange={handleChange}
                                            numMin={values.idadeDataSimulacaoCliente}
                                            numMax={values.idadeExpectativaVidaCliente}
                                        />
                                    </GridItem3xs10>
                                )}

                                {existeTabelaEvolucaoValorResgate(values, HARDCODE.idFamiliarConjuge) && (
                                    <GridItem3xs10>
                                        <TextValidatorNumber
                                            name={"idadeSimularResgateVidaInteiraConjuge"}
                                            label={LABEL.idadeSimularResgateVidaInteira.replace("$1$", tituloConjuge(values))}
                                            value={
                                                values.idadeSimularResgateVidaInteiraConjuge === 0
                                                    ?
                                                        0
                                                    :
                                                        values.idadeSimularResgateVidaInteiraConjuge || ''
                                            }
                                            onChange={handleChange}
                                            numMin={values.idadeDataSimulacaoConjuge}
                                            numMax={values.idadeExpectativaVidaConjuge}
                                        />
                                    </GridItem3xs10>
                                )}
                                
                                {(values.idadeSimularResgateVidaInteiraCliente || values.idadeSimularResgateVidaInteiraConjuge) && (
                                    <GridItem9>
                                        <CheckboxPadrao
                                            name="aplicarTaxaInflacaoSimulacaoResgateVidaInteira"
                                            label={LABEL.aplicarTaxaInflacaoSimulacaoResgateVidaInteira}
                                            checked={values.aplicarTaxaInflacaoSimulacaoResgateVidaInteira}
                                            onChange={handleChange}
                                        />
                                    </GridItem9>
                                )}

                                <GridItem9>
                                    <CheckboxPadrao
                                        name="aplicarTaxaInflacaoCarteiraInvestimentos"
                                        label={LABEL.aplicarTaxaInflacaoCarteiraInvestimentos}
                                        checked={values.aplicarTaxaInflacaoCarteiraInvestimentos}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.protecaoSucessaoVitalicia/*tabelaEvolucaoValorResgate*/}
                        >
                            <GridContainer>
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirResumoSeguroVidaCotacao"
                                        label={LABEL.exibirResumoSeguroVidaCotacao}
                                        checked={values.exibirResumoSeguroVidaCotacao}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                                
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado"
                                        label={LABEL.exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado}
                                        checked={values.exibirPercPremioAnualizadoAcumuladoEmRelacaoCapitalSegurado}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                                
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirValorResgateSomenteAPartirQuitacaoSeguroVidaInteira"
                                        label={LABEL.exibirValorResgateSomenteAPartirQuitacaoSeguroVidaInteira}
                                        checked={values.exibirValorResgateSomenteAPartirQuitacaoSeguroVidaInteira}
                                        onChange={handleChange}
                                    />
                                </GridItem9>

                                {/*
                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirEconomiaInventarioSeguroVidaTabelaEvolucaoValorResgate"
                                        label={LABEL.exibirEconomiaInventarioSeguroVidaTabelaEvolucaoValorResgate}
                                        checked={values.exibirEconomiaInventarioSeguroVidaTabelaEvolucaoValorResgate}
                                        onChange={handleChange}
                                    />
                                </GridItem9>
                                */}

                                <GridItem9>
                                    <CheckboxPadrao
                                        name="aplicarTaxaInflacaoTabelaEvolucaoValorResgate"
                                        label={LABEL.aplicarTaxaInflacaoTabelaEvolucaoValorResgate}
                                        checked={values.aplicarTaxaInflacaoTabelaEvolucaoValorResgate}
                                        onChange={handleChange}
                                    />
                                </GridItem9>

                                {values.aplicarTaxaInflacaoTabelaEvolucaoValorResgate && (
                                    <>
                                        <GridItem9
                                            className='ml-15'
                                        >
                                            <CheckboxPadrao
                                                name="calcularPremioAnualizadoAcumuladoSomaSimples"
                                                label={LABEL.calcularPremioAnualizadoAcumuladoSomaSimples}
                                                checked={values.calcularPremioAnualizadoAcumuladoSomaSimples}
                                                onChange={handleChange}
                                            />
                                        </GridItem9>

                                        <GridItem9
                                            className='ml-15'
                                        >
                                            <CheckboxPadrao
                                                name="exibirTambemTabelaEvolucaoValorResgateSemTaxaInflacao"
                                                label={LABEL.exibirTambemTabelaEvolucaoValorResgateSemTaxaInflacao}
                                                checked={values.exibirTambemTabelaEvolucaoValorResgateSemTaxaInflacao}
                                                onChange={handleChange}
                                            />
                                        </GridItem9>
                                    </>
                                )}

                                <GridItem5xs10>
                                    <CheckboxPadrao
                                        name="limitarQtdeAnosExibidosGraficosTabelasEvolucao"
                                        label={LABEL.limitarQtdeAnosExibidosGraficosTabelasEvolucao}
                                        checked={values.limitarQtdeAnosExibidosGraficosTabelasEvolucao}
                                        onChange={handleChange}
                                    />
                                </GridItem5xs10>

                                {values.limitarQtdeAnosExibidosGraficosTabelasEvolucao && (
                                    <GridItem2xs4>
                                        <TextValidatorNumber
                                            name="anosLimitarQtdeAnosExibidosGraficosTabelasEvolucao"
                                            label={LABELESPECIAL.anos}
                                            value={
                                                values.anosLimitarQtdeAnosExibidosGraficosTabelasEvolucao === 0
                                                    ?
                                                        0
                                                    :
                                                        values.anosLimitarQtdeAnosExibidosGraficosTabelasEvolucao || ''
                                            }
                                            onChange={handleChange}
                                            numMin={NUMMIN.anos}
                                            numMax={NUMMAX.anos}
                                        />
                                    </GridItem2xs4>
                                )}

                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirTabelaEvolucaoCS"
                                        label={LABEL.exibirTabelaEvolucaoCS}
                                        checked={values.exibirTabelaEvolucaoCS}
                                        onChange={handleChange}
                                    />
                                </GridItem9>

                                <GridItem9>
                                    <CheckboxPadrao
                                        name="exibirTabelaEvolucaoCancelamentoApolice"
                                        label={LABEL.exibirTabelaEvolucaoCancelamentoApolice}
                                        checked={values.exibirTabelaEvolucaoCancelamentoApolice}
                                        onChange={handleChange}
                                    />
                                </GridItem9>

                                <GridItem6>
                                    <CheckboxPadrao
                                        name="exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira"
                                        label={LABEL.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira}
                                        checked={values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira}
                                        onChange={handleChange}
                                    />
                                </GridItem6>

                                <GridItem6>
                                    <CheckboxPadrao
                                        name="exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira"
                                        label={LABEL.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira}
                                        checked={values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira}
                                        onChange={handleChange}
                                    />
                                </GridItem6>

                                {(values.exibirGraficoAnaliseInvestimentoVersusSeguroVidaInteira || 
                                values.exibirGraficoAnalisePrevidenciaPrivadaVersusSeguroVidaInteira
                                ) && (
                                    <GridContainer
                                        className='ml-15'
                                    >
                                        <GridContainer>
                                            <GridItem4xs8>
                                                <TextFieldTextSelect
                                                    name="graficoAnaliseInvestimentoVersusSeguroVidaInteiraTipoMomentoTributacaoIR"
                                                    label={LABEL.graficoAnaliseInvestimentoVersusSeguroVidaInteiraTipoMomentoTributacaoIR}
                                                    value={values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraTipoMomentoTributacaoIR || ''}
                                                    onChange={handleChange}
                                                    list={tipoMomentoTributacaoIRList}
                                                />
                                            </GridItem4xs8>

                                            {(values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraTipoMomentoTributacaoIR ===
                                            HARDCODE.tipoMomentoTributacaoIRComeCotas ||
                                            values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraTipoMomentoTributacaoIR ===
                                            HARDCODE.tipoMomentoTributacaoIRPGBL ||
                                            values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraTipoMomentoTributacaoIR ===
                                            HARDCODE.tipoMomentoTributacaoIRVGBL ||
                                            values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraTipoMomentoTributacaoIR ===
                                            HARDCODE.tipoMomentoTributacaoIRResgate) && (
                                                <GridItem2xs4>
                                                    <TextValidatorNumberRequired
                                                        name="graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercIR"
                                                        label={LABEL.graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercIR}
                                                        value={
                                                            values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercIR === 0
                                                                ?
                                                                    0
                                                                :
                                                                    values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercIR || ''
                                                        }
                                                        onChange={handleChange}
                                                        numMin={NUMMIN.percIR}
                                                        numMax={NUMMAX.percIR}
                                                    />
                                                </GridItem2xs4>
                                            )}
                                        </GridContainer>

                                        <GridItem9>
                                            <CheckboxPadrao
                                                name="graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarDespesasAdvocaticiasCustasJudiciais"
                                                label={LABEL.graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarDespesasAdvocaticiasCustasJudiciais}
                                                checked={values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarDespesasAdvocaticiasCustasJudiciais}
                                                onChange={handleChange}
                                            />
                                        </GridItem9>

                                        <GridItem9>
                                            <CheckboxPadrao
                                                name="graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarItcmd"
                                                label={LABEL.graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarItcmd}
                                                checked={values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraConsiderarItcmd}
                                                onChange={handleChange}
                                            />
                                        </GridItem9>

                                        <GridContainer>
                                            <GridItem2xs4>
                                                <TextValidatorNumber
                                                    name="graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercDesagio"
                                                    label={LABEL.graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercDesagio}
                                                    value={
                                                            values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercDesagio === 0
                                                                ?
                                                                    0
                                                                :
                                                                    values.graficoAnaliseInvestimentoVersusSeguroVidaInteiraPercDesagio || ''
                                                    }
                                                    onChange={handleChange}
                                                    numMin={NUMMIN.taxa}
                                                    numMax={NUMMAX.taxa}
                                                />
                                            </GridItem2xs4>
                                        </GridContainer>
                                    </GridContainer>
                                )}
                            </GridContainer>
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.sucessaoVitalicia}
                        >
                            {!values.utilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia && (
                                <GridContainer>
                                    <GridItem9>
                                        <IncluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem9>
                                </GridContainer>
                            )}

                            {!values.incluirSugestaoPrevidenciaPrivadaSeguroVidaInteiraSucessaoVitalicia && (
                                <GridContainer>
                                    <GridItem9>
                                        <UtilizarPrevidenciaPrivadaDeduzirNecessidadeSucessaoVitalicia
                                            values={values}
                                            handleChange={handleChange}
                                        />
                                    </GridItem9>
                                </GridContainer>
                            )}
                        </CardGridEntradaDadosHeaderBody>
                    </CardGridEntradaDados>
                </GridItem8sm12xs12>
            </GridContainer>
        </ValidatorForm>
    )
}

export default EstudoFormConfiguracaoGestaoPatrimonial